import { env } from "../config/env";
import { createClient } from "./http";

const reportApi = createClient(env.REPORT_BASE_URL);
const orderApi = createClient(env.ORDER_BASE_URL);
const warehouseInventoryApi = createClient(env.WAREHOUSE_INVENTORY_BASE_URL);
const settingsApi = createClient(env.WAREHOUSE_BASE_URL);

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export const paymentCollectionsService = {
  admin: {
    getSummary(params = {}) {
      return reportApi.get("/api/reports/payment-collections/summary", { params: cleanParams(params) });
    },
    getDrivers(params = {}) {
      return reportApi.get("/api/reports/payment-collections/drivers", { params: cleanParams(params) });
    },
    getCollections(params = {}) {
      return reportApi.get("/api/reports/payment-collections/collections", { params: cleanParams(params) });
    },
    getSettlements(params = {}) {
      return reportApi.get("/api/reports/payment-collections/settlements", { params: cleanParams(params) });
    },
    getCollectionEvents(collectionId, params = {}) {
      return orderApi.get(`/api/admin/payment-collections/collections/${encodeURIComponent(collectionId)}/events`, {
        params: cleanParams(params),
      });
    },
    getSettlement(settlementId) {
      return orderApi.get(`/api/admin/payment-collections/settlements/${encodeURIComponent(settlementId)}`);
    },
    createSettlement(payload) {
      return orderApi.post("/api/admin/payment-collections/settlements", payload);
    },
    verifySettlement(settlementId) {
      return orderApi.post(`/api/admin/payment-collections/settlements/${encodeURIComponent(settlementId)}/verify`, {});
    },
    rejectSettlement(settlementId, reason = "") {
      return orderApi.post(`/api/admin/payment-collections/settlements/${encodeURIComponent(settlementId)}/reject`, { reason });
    },
    resolveReview(collectionId, payload) {
      return orderApi.post(`/api/admin/payment-collections/collections/${encodeURIComponent(collectionId)}/resolve-review`, payload);
    },
    getSettings() {
      return settingsApi.get("/api/admin/payment-collection-settings");
    },
    updateSettings(payload) {
      return settingsApi.patch("/api/admin/payment-collection-settings", payload);
    },
  },

  warehouse: {
    getSummary(params = {}) {
      return warehouseInventoryApi.get("/api/warehouse/payment-collections/summary", { params: cleanParams(params) });
    },
    getDrivers(params = {}) {
      return warehouseInventoryApi.get("/api/warehouse/payment-collections/drivers", { params: cleanParams(params) });
    },
    getCollections(params = {}) {
      return warehouseInventoryApi.get("/api/warehouse/payment-collections/collections", { params: cleanParams(params) });
    },
    getSettlements(params = {}) {
      return warehouseInventoryApi.get("/api/warehouse/payment-collections/settlements", { params: cleanParams(params) });
    },
    getCollectionEvents(collectionId, params = {}) {
      return warehouseInventoryApi.get(`/api/warehouse/payment-collections/collections/${encodeURIComponent(collectionId)}/events`, {
        params: cleanParams(params),
      });
    },
    getSettlement(settlementId) {
      return warehouseInventoryApi.get(`/api/warehouse/payment-collections/settlements/${encodeURIComponent(settlementId)}`);
    },
    createSettlement(payload) {
      return warehouseInventoryApi.post("/api/warehouse/payment-collections/settlements", payload);
    },
    verifySettlement(settlementId) {
      return warehouseInventoryApi.post(`/api/warehouse/payment-collections/settlements/${encodeURIComponent(settlementId)}/verify`, {});
    },
    rejectSettlement(settlementId, reason = "") {
      return warehouseInventoryApi.post(`/api/warehouse/payment-collections/settlements/${encodeURIComponent(settlementId)}/reject`, { reason });
    },
    getSettings() {
      return warehouseInventoryApi.get("/api/warehouse/payment-collections/settings");
    },
    updateSettings(payload) {
      return warehouseInventoryApi.patch("/api/warehouse/payment-collections/settings", payload);
    },
  },
};
